var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgL2Hoclaixe = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#E9EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 10.0736C19.7731 10.0779 15.9603 11.6596 13.1481 14.4717C10.336 17.2838 8.7543 21.0966 8.75 25.0736C9.5 44.9486 38 44.9398 38.75 25.0736C38.7457 21.0966 37.164 17.2838 34.3519 14.4717C31.5397 11.6596 27.7269 10.0779 23.75 10.0736ZM23.75 13.8236C25.9699 13.8257 28.1396 14.4837 29.9868 15.7148C31.834 16.946 33.2763 18.6955 34.1325 20.7436L26.28 22.3148C24.5512 22.6598 22.7713 22.6598 21.0425 22.3148L13.3538 20.7761C14.206 18.7198 15.6483 16.9621 17.4985 15.7247C19.3488 14.4874 21.5241 13.8258 23.75 13.8236ZM12.5075 25.4573L16.45 26.2461C17.1697 26.39 17.8488 26.6907 18.4392 27.1266C19.0296 27.5626 19.5168 28.1231 19.8663 28.7686L20.6475 30.2098C21.0419 30.9394 21.2489 31.7555 21.25 32.5848V36.0386C18.8311 35.4834 16.6631 34.1454 15.0824 32.2321C13.5016 30.3189 12.5965 27.9375 12.5075 25.4573ZM26.25 36.0436V32.5898C26.2511 31.7605 26.4581 30.9444 26.8525 30.2148L27.6338 28.7736C27.9832 28.1281 28.4704 27.5676 29.0608 27.1316C29.6512 26.6957 30.3303 26.395 31.05 26.2511L34.9925 25.4623C34.9035 27.9425 33.9984 30.3239 32.4176 32.2371C30.8369 34.1504 28.6689 35.4884 26.25 36.0436Z",
    fill: "url(#paint0_linear_51_954)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_954",
    x1: 8.75,
    y1: 22.7823,
    x2: 38.75,
    y2: 22.7823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL2Hoclaixe, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L2hoclaixe.6eca08ce.svg";
export { ForwardRef as ReactComponent };